import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ExportDataDropDown from '@/components/molecules/ExportDataDropDown';
import DownloadOptions from '@/components/molecules/ExportDataDropDown/DownloadOptions';
import type { DomainCageOverview } from '@/domain/cages/overview.types';

import { buildOverviewDownload } from '../helpers/buildOverviewDownload';
import { cageOverviewExportOptions } from '../helpers/cageOverviewExport';

interface OverviewExportProps {
    overview: DomainCageOverview;
    /** Only this daypart's days are exported. */
    daypartTag: string;
    /**
     * While the overview loads. A download then would hold only the location columns and read
     * as a cage with no measured days.
     */
    disabled?: boolean;
}

/** The page's download menu: the measured days, plus the hourly environmental snapshot. */
export default function OverviewExport(props: OverviewExportProps) {
    const { overview, daypartTag, disabled = false } = props;
    const { t } = useTranslation();

    const { rows, columns } = useMemo(
        () => buildOverviewDownload(overview, daypartTag),
        [overview, daypartTag]
    );
    const { sheetName, extraSheet } = cageOverviewExportOptions(overview.environmental, t);

    return (
        <ExportDataDropDown disabled={disabled}>
            <DownloadOptions
                data={rows}
                columns={columns}
                sheetName={sheetName}
                extraSheet={extraSheet}
            />
        </ExportDataDropDown>
    );
}
